import { render, staticRenderFns } from "./ResultsPanel.vue?vue&type=template&id=a5b4c918&scoped=true"
import script from "./ResultsPanel.vue?vue&type=script&lang=js"
export * from "./ResultsPanel.vue?vue&type=script&lang=js"
import style0 from "./ResultsPanel.vue?vue&type=style&index=0&id=a5b4c918&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4c918",
  null
  
)

export default component.exports